// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._19it1ebc{border:var(--stroke-width) solid var(--stroke-color)}\n._2rko1koq{border-radius:var(--border-radius)}._152tidpf{inset-block-start:0}\n._1e02armj{inset-inline-start:var(--indent)}\n._kqswstnw{position:absolute}\n._lcxvglyw{pointer-events:none}\n._rjxpidpf{inset-inline-end:0}\n._u7coidpf{inset-block-end:0}", ""]);
// Exports
module.exports = exports;
